import { render, staticRenderFns } from "./BankingAccountCreatePage.vue?vue&type=template&id=ee4ba6f0&"
import script from "./BankingAccountCreatePage.vue?vue&type=script&lang=ts&"
export * from "./BankingAccountCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports